import TableauShowDisconnectButton from "th/tableauShowDisconnectButton";

export { TableauShowDisconnectButton };

customElements.define(
  "th-tableau-show-disconnect-button",
  TableauShowDisconnectButton.CustomElementConstructor
);
